"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gl_resource_1 = __importDefault(require("./gl-utils/gl-resource"));
var Parameters = __importStar(require("./parameters"));
var BrushShaders = __importStar(require("./shaders/brush-shaders"));
var Brush = (function (_super) {
    __extends(Brush, _super);
    function Brush(gl) {
        var _this = _super.call(this, gl) || this;
        _this._drawShader = BrushShaders.buildDrawShader(gl);
        _this.thickness = 2;
        return _this;
    }
    Brush.prototype.freeGLResources = function () {
        this._drawShader.freeGLResources();
    };
    Brush.prototype.draw = function () {
        var gl = _super.prototype.gl.call(this);
        var canvas = gl.canvas;
        var canvasSize = [canvas.clientWidth, canvas.clientHeight];
        var drawShader = this._drawShader;
        drawShader.use();
        var brushSize = [
            Parameters.brush.radius / canvasSize[0],
            Parameters.brush.radius / canvasSize[1]
        ];
        drawShader.u["uBrushSize"].value = brushSize;
        drawShader.u["uBrushPos"].value = Parameters.mouse.pos;
        drawShader.u["uThickness"].value = this.thickness / Parameters.brush.radius;
        drawShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    return Brush;
}(gl_resource_1.default));
exports.default = Brush;
